module.exports = __webpack_public_path__ + "img/LogoDashboard-29.94a16b29.svg";